module.exports = __webpack_public_path__ + "img/how-to-save-from-extension-dark.35c6e670.svg";